(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/tipsen/sportkryss.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/tipsen/sportkryss.js');

'use strict';

svs.game_results.views.Sportkryss = Marionette.View.extend({
  className: 'sportkryss-results',
  events: {
    'click .js-get-sportkryss-draw': 'getSportkryssDraw'
  },
  template(data) {
    return svs.game_results.templates.sportkryss(data);
  },
  modelEvents: {
    'change:sportkryssResult change:regCloseTime': 'render'
  },
  shouldShowSportkryssResult() {
    return this.model.get('regCloseTime') && new Date(this.model.get('regCloseTime')) >= new Date(svs.game_results.constants.sportkryssJokerBreakDate.DATE) || false;
  },
  onBeforeRender() {
    this.model.set('shouldShowSportkryssResult', this.shouldShowSportkryssResult());
  },
  getSportkryssDraw() {
    if (!this.model.get('sportkryssResult')) {
      this.model.getSportkryssResult(this.model.get('regCloseTime'));
      return true;
    }
  }
});

 })(window);